// Copyright: IQGeo Limited 2010-2019

const utils = {
    /*
     * Removes consecutive duplicate coordinates from self
     */
    withoutDuplicates(coords) {
        const uniquePoints = [];
        let prev = null;

        for (const c of coords) {
            if (!prev || c[0] !== prev[0] || c[1] !== prev[1]) {
                uniquePoints.push(c);
            }
            prev = c;
        }

        return uniquePoints;
    }
};

export default utils;
